// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"308":"40209851","487":"737317ef","801":"ebd965b9"}[chunkId] + ".js";
};